import * as React from "react";
import { FastField } from "formik";
import { FormGroup } from "@lib/components";
import { Button } from "@lib/components";
import { RotateLoader } from "@lib/components";
import { Input } from "@lib/components";
import { Switch } from "@lib/components";
import { UI } from "../../../../../../../core/ui";
import { MobxComponent } from "../../../../../../../mobx/components/index";
import { inject, observer } from "mobx-react";
import { RestaurantForm } from "../../../../../../../mobx/components/restaurant-form";

interface Props {
	close?: () => void;
}
interface State {}

type FormValues = T.Schema.Restaurant.RestaurantSchema["wpos"];

@inject("store") @observer
export class SettingsFormIntegrationWPOS extends MobxComponent<Props, State> {

	initialValues: FormValues;

	constructor(props: Props) {
		super(props);
		this.state = {};
		const r = this.injected.store.restaurant!;
		this.initialValues = r.wpos;
	}

	render() {
		return (
			<RestaurantForm<FormValues>
				submit={async (r, values) => {
					r.wpos = values;
					if (!r.wpos) {
						r.wpos = {}
					}
					r.wpos.wpos_open_item_list = this.injected.store.restaurant && this.injected.store.restaurant.wpos ? this.injected.store.restaurant.wpos.wpos_open_item_list : [];
					const update = { $set: { "wpos": r.wpos } };
					return { r, update };
				}}
				initialValues={this.initialValues}
				onSuccess={() => {
					if (this.props.close) {
						this.props.close();
					}
				}}
				onError={() => UI.notification.error("An error occurred")}
				onSuccessMessage="Settings Updated"
			>
				{({ form, error }) => {
					const { isSubmitting, setFieldValue } = form;
					return (
						<div className="p-4">
							<FastField
								name="wpos_api_key"
								render={({ field }: any) => (
									<FormGroup
										title="PushPOS API Key"
										help="Your unique PushPOS API key. This is provided under your PushPOS account settings."
									>
										<Input
											type="text"
											{...field}
											value={field.value || ""}
											required={true}
										/>
									</FormGroup>
								)}
							/>

							<FastField
								name="wpos_status"
								render={({ field }: any) => (
									<FormGroup
										title="Enabled"
										help="Turning this on will enable the PushPOS features in the Menus and automatic sending of orders to your POS."
									>
										<Switch
											id="wpos-enabled-switch"
											checked={field.value || false}
											onChange={(e) =>
												setFieldValue(
													"wpos_status",
													e.target.checked
												)
											}
										/>
									</FormGroup>
								)}
							/>

							<FastField
								name="wpos_manual_sync"
								render={({ field }: any) => (
									<FormGroup
										title="Manual Sync"
										help="Off: menu changes are sent a few seconds after you stop editing. On: changes are only sent when you press Sync to POS on the Menus screen. That button is there in both modes, so you can always push or retry a sync by hand."
									>
										<Switch
											id="wpos-manual-sync-switch"
											checked={field.value || false}
											onChange={(e) =>
												setFieldValue(
													"wpos_manual_sync",
													e.target.checked
												)
											}
										/>
									</FormGroup>
								)}
							/>

							{/* <FastField
								name="wpos_open_items"
								render={({ field }: any) => (
									<FormGroup
										title="Open Items (Admin Use Only)"
										help="Do not use. This will break the link to WPOS"
									>
										<Switch
											id="enabled-open-items"
											checked={field.value || false}
											onChange={(e) =>
												setFieldValue(
													"wpos_open_items",
													e.target.checked
												)
											}
										/>
									</FormGroup>
								)}
							/> */}

							{/* <FastField
								name="wpos_kitchen_display_mode"
								render={({ field }: any) => (
									<FormGroup
										title="Kitchen Display Mode"
										help="Use Kitchen Display Mode"
									>
										<Switch
											id="enabled-wpos_kitchen_display_mode"
											checked={field.value || false}
											onChange={(e) =>
												setFieldValue(
													"wpos_kitchen_display_mode",
													e.target.checked
												)
											}
										/>
									</FormGroup>
								)}
							/> */}




							{error && <FormGroup error={error} />}

							<Button
								full={true}
								color="primary"
								type="submit"
								disabled={isSubmitting}
							>
								{isSubmitting && (
									<RotateLoader size={2} color="white" />
								)}
								{!isSubmitting && "Save"}
							</Button>
						</div>
					);
				}}
			</RestaurantForm>
		);

	}

}
